export const END_POINTS = {
  ME: '/api/auth/me',
  SEND_OTP: '/api/otp',
  UPDATE_COGNITO_PHONE: '/api/customer/phone/update-cognito-phone',
  GET_COGNITO_RECOVERY_METHOD: '/api/auth/cognito-recovery-method',
  GENERATE_CLIENT_TOKEN: '/api/account/generate-card-token',

  ON_BOARDING: {
    CARD_APPLICATION: '/api/account/register',
    DISMISS_BANNER: '/api/customer/',
    DISMISS_FIRST_LOGIN_MODAL: '/api/customer/first-login-modal',
    ADD_VEHICLES: '/api/vehicles',
    SET_USER_REFERRAL_DATA: '/api/customer/',
  },
  REFERENCE_DATA: {
    GET_VEHICLE_MAKES: '/api/reference/vehicle-makes',
    GET_VEHICLE_MODELS: '/api/reference/vehicle-models',
  },
  PAYMENT: {
    PLAID: {
      CREATE_LINK_TOKEN: '/api/plaid/create-link-token',
      EXCHANGE_PUBLIC_TOKEN: '/api/plaid/exchange-public-token',
      GET_PLAID_ITEMS: '/api/plaid/items',
      SYNC_PLAID_ITEMS: '/api/plaid/items/sync',
      DELETE_PLAID_ITEM: '/api/plaid/items',
    },
    BANK_ACCOUNTS: '/api/bank-accounts',
    SCHEDULE_PAYMENT: '/api/schedule-one-time-payment',
    SCHEDULE_RECURRING_PAYMENT: '/api/schedule-recurring-payment',
    SCHEDULE_RECURRING_PAYMENT_V2: '/api/schedule-recurring-payment-v2',
    RECURRING_PAYMENT: '/api/recurring-payment',
    PAYMENT_HISTORY: '/api/payment-history-v2',
    CANCEL_ACH_REPAYMENT: '/api/cancel-ach-repayment',
    RECURRING_PAYMENT_V2: '/api/recurring-payment-v2',
    HAS_ONE_TIME_PAYMENTS: '/api/has-one-time-payments',
    PAYMENT_METHODS: '/api/payment-methods',
    UPDATE_REWARD_ELIGIBLE_STATUS: '/api/reward-eligible-status',
  },
  TRANSACTIONS: {
    BASE: '/api/transactions',
    PENDING_TRANSACTIONS: '/api/transactions/pending-transactions',
    CURRENT_MONTH_SPENDING: '/api/transactions/current-month-spending',
    LOANS: {
      GET_PLAID_LOAN_TRANSACTIONS: '/api/transactions/loans/plaid',
      SUBMIT_LOAN_TRANSACTIONS_FOR_REVIEW: '/api/transactions/loans/submit-for-review',
    },
  },
  STATEMENTS: {
    ACCOUNT_SUMMARY: '/api/statements/account-summary',
    STATEMENTS_HISTORY: '/api/statements',
    PDF_STATEMENT: '/api/statements',
  },
  DOCUMENT_UPLOAD: {
    SESSION: '/api/document-upload/session',
    TOKEN: '/api/document-upload/token',
    SESSION_START: '/api/document-upload/session/start',
    UPLOAD_LINK: '/api/document-upload/link',
    SESSION_END: '/api/document-upload/session/end',
  },
  CARD_MANAGEMENT: {
    ACTIVATE_CARD: '/api/account/activate-card',
    UPDATE_CARD_STATUS: '/api/account/update-card-status',
    VIEW_SECURE_CARD_DETAILS: '/api/account/card-details',
    REISSUE_CARD: '/api/account/reissue-card',
  },
  VEHICLES: {
    GET_VEHICLES: '/api/vehicles',
    DELETE_VEHICLES: '/api/vehicles/',
    UPDATE_VEHICLES: '/api/vehicles/',
    CHECK_VIN_AVAILABILITY: '/api/vehicles/validate-vin/',
  },
  REWARDS: {
    GET_REWARDS_SUMMARY: '/api/account/rewards-summary',
    REWARD_ACTIVITIES: '/api/account/rewards-activities',
    REDEEMABLE_POINTS: '/api/account/redeemable-points',
    REDEEM_POINTS: '/api/account/redeem',
    GET_REWARDS_POINTS: '/api/account/rewards-points',
    GET_REDEMPTION_STATUS: '/api/account/check-redemption-status',
  },
  REDEMPTION: {
    GET_ELIGIBLE_EXPENSES: '/api/redemption/eligible-expenses',
  },
  SHINE_AND_DRIVE: {
    SEARCH_LOCATIONS: '/api/shine-and-drive/locations',
  },
  DEALERSHIP: {
    GET_ALL_DEALERSHIPS: '/api/dealerships',
  },
  BUSINESS_LOCATION: {
    GET_ALL_BUSINESS_LOCATIONS: '/api/business-locations',
  },
  ACCOUNT: {
    GET_CONSENTED_DOC_VERSIONS: '/api/customer/consent/getConsentedDocs',
  },
  SYNC_HIGHNOTE_DATA: '/sync/highnote-data',
  // Odynn/Awayz verification endpoint
  ODYNN_VERIFY: '/api/auth/odynn',
  ZENDESK_VERIFY: '/api/auth/zendesk',
  PREQUAL: '/api/prequal',
  VALIDATE_PROMO_CODE: '/api/promo-code/validate',
  GET_ACTIVE_PROMO_CODE: '/api/promo-code/active',
  SYNC_REFERRAL_DATA: '/api/promo-code/sync-referral',
}
